// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__191HE","header":"Messages_header__3Wzmv"};